module.exports = __webpack_public_path__ + "static/media/ems-standards.bfba2972.png";